import { render, staticRenderFns } from "./ViewNetworkAds.vue?vue&type=template&id=1944bd6d&scoped=true&"
import script from "./ViewNetworkAds.vue?vue&type=script&lang=js&"
export * from "./ViewNetworkAds.vue?vue&type=script&lang=js&"
import style0 from "./ViewNetworkAds.vue?vue&type=style&index=0&id=1944bd6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944bd6d",
  null
  
)

export default component.exports